import styled from 'styled-components';
import { gridSizes, media } from 'utils/style';

import FaqsWithMarkup from 'components/ModalFaqs/Sections/FaqsWithMarkup/container';

export default styled(FaqsWithMarkup)`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: visible;

  ${media.lessThan('medium')`
overflow-y: auto;
`};

  section {
    width: 100%;
    margin: 0 auto;
    padding: ${gridSizes('L')} ${gridSizes('L')};
    overflow: hidden;

    font-size: 16px;

    color: #54708c;

    .faqs-content {
      padding-bottom: 100px;
    }

    .title {
      h2 {
        margin: 0;
        padding: 16px 0px;
        color: #263340;
      }
    }
    img {
      max-width: 600px;
    }

    p {
      line-height: 1.21;

      &:not(> strong) {
        color: red;
      }

      strong {
        font-size: 20px;
        font-weight: 500;
        color: #263340;
        display: block;
        margin-top: 3rem;
      }

      a {
        color: rgb(1, 64, 205);
      }
    }
  }

  table {
    width: 100%;
    border: none;
    border-spacing: 0;

    thead {
      background: #5b6d78;
      color: #fff;
      th {
        padding: 8px;
        padding-left: 12px;
        font-weight: 200;
        text-align: left;
      }
    }

    tbody {
      tr {
        &:nth-child(even) {
          background: #f0f2f6;
        }
      }

      td {
        padding: 8px;
        padding-left: 12px;
        font-weight: 200;
        text-align: left !important;
      }
    }
  }
`;
